<script setup lang="ts">
import { UiCurrencyInput, UiTextInput } from "@/components"
import type { FieldErrorResolver, SalesOrderFormState } from "./types"

defineProps<{
  formState: SalesOrderFormState
  fieldError: FieldErrorResolver
}>()
</script>

<template>
  <section class="rounded-md border border-slate-200 p-4">
    <h2 class="mb-3 text-sm font-semibold text-slate-800">Parametros do snapshot projetado</h2>

    <div class="grid gap-4 md:grid-cols-4">
      <UiTextInput
        id="sales-order-tax"
        v-model="formState.estimated_tax_percent"
        type="number"
        step="0.01"
        label="Imposto estimado (%)"
        :error="fieldError('estimated_tax_percent')"
      />

      <UiCurrencyInput
        id="sales-order-freight"
        v-model="formState.estimated_freight_cents"
        label="Frete estimado"
        :error="fieldError('estimated_freight_cents')"
      />

      <UiTextInput
        id="sales-order-packaging"
        v-model="formState.packaging_percent"
        type="number"
        step="0.01"
        label="Embalagem (%)"
        :error="fieldError('packaging_percent')"
      />

      <UiTextInput
        id="sales-order-overhead"
        v-model="formState.indirect_costs_percent"
        type="number"
        step="0.01"
        label="Custos indiretos (%)"
        helper-text="Aplica percentual sobre o custo de materia-prima para representar despesas indiretas."
        :error="fieldError('indirect_costs_percent') || fieldError('overhead_percent')"
      />
    </div>
  </section>
</template>

